import React, { useState, useMemo } from 'react';
import { RootState } from 'store/ducks';
import { useSelector } from 'react-redux';

import TableHealthOperator from '../TableHealthOperator';
import { TableDataIntegrationProps } from './interface';

export const TableDataIntegration: React.FC<TableDataIntegrationProps> = (props) => {

  const {
    trackingKey,
    model,
    dataIntegration,
    currentPage,
    setCurrentPage,
    pageSize,
    DropdownTemplate,
  } = props;

  const user = useSelector((state: RootState) => state.user);
  const customer = useSelector((state: RootState) => state.customer);

  const [tableOrderBy, setTableOrderBy] = useState('desc');

  const pageTotal = pageSize || 10;

  const onReloadDateIfError = () => {
    setCurrentPage(0);
  };

  const TableDataIntegration = useMemo(() => (
    <TableHealthOperator
      trackingKey={trackingKey}
      onReload={onReloadDateIfError}
      setTableOrder={setTableOrderBy}
      error={dataIntegration?.error || false}
      tableOrder={tableOrderBy}
      DropdownTemplate={DropdownTemplate || undefined}
      currentPage={currentPage}
      data={dataIntegration?.data}
      pageSize={pageTotal}
      onPageChange={setCurrentPage}
      totalPages={dataIntegration?.totalPages}
      total={dataIntegration.total}
      model={model || []}
    />
  ), [dataIntegration, user?.selectedCustomerId, customer, tableOrderBy]);

  return (
    <>
      {TableDataIntegration}
    </>
  );
};
